module.exports = __webpack_public_path__ + "static/media/Login_Logo2.f8634bbb.png";